import { createStyles } from 'antd-style';

import { ThemeFont } from '../../../../theme';

export const useAddressContactSectionStyles = createStyles(({ token }) => ({
  flightInfoSection: {
    fontFamily: token.fontFamily,
    fontSize: token.fontSizeSM,
    fontWeight: 400,
    marginTop: 0,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
}));
